import { Box, Button, Typography } from "@mui/material";
import { NavLink as RouterLink } from "react-router-dom";
import EditControls from "../EditControls";

interface RateTableListToolbarProps {
  name: string;
  canDelete: boolean;
  editing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onDelete: () => void;
}

const RateTableListToolbar = ({
  name,
  canDelete,
  editing,
  onEdit,
  onSave,
  onCancel,
  onDelete,
  ...rest
}: RateTableListToolbarProps) => (
  <Box {...rest}>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography variant="h1">{name}</Typography>
      </Box>
      <Box>
        <Button component={RouterLink} to={"/app/rateTables"}>
          &lt;&lt; Back
        </Button>
        <EditControls
          editing={editing}
          canDelete={canDelete}
          onEdit={onEdit}
          onSave={onSave}
          onCancel={onCancel}
          onDelete={onDelete}
        />
      </Box>
    </Box>
  </Box>
);

export default RateTableListToolbar;
